// frontend/src/hooks/photoInboxKeys.ts
/**
 * React Query keys for a tank's photo inbox. Invalidating `tank(tankId)`
 * refreshes everything under it: the count, the pages and single photos.
 */
export const photoInboxKeys = {
  all: ['photo-inbox'] as const,
  tank: (tankId: string) => ['photo-inbox', tankId] as const,
  count: (tankId: string) => ['photo-inbox', tankId, 'count'] as const,
  list: (tankId: string) => ['photo-inbox', tankId, 'list'] as const,
  item: (tankId: string, id: number) => ['photo-inbox', tankId, 'item', id] as const,
  /** Photos assigned since the app was opened (kept in the cache only, never fetched). */
  session: (tankId: string) => ['photo-inbox', tankId, 'session'] as const,
  /** Mutation keys, so a view can follow sends it didn't start (useMutationState). */
  assignMutation: ['photo-inbox-assign'] as const,
  discardMutation: ['photo-inbox-discard'] as const,
};
